module.exports = __webpack_public_path__ + "img/9788925534350.f78eaeb5.jpg";